export const formatFile = (file, fileType) => {
  if (!file) return Promise.resolve("");

  const fileReader = new FileReader();
  return new Promise((resolve) => {
    fileReader.onload = function (fileLoadedEvent) {
      const base64 = fileLoadedEvent.target.result;
      const dataPrefixes = {
        pdf: "data:application/pdf;base64,",
        xls: "data:application/vnd.ms-excel;base64,",
        xlsx: "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
      };
      const dataPrefix = dataPrefixes[fileType] || "";
      const dataFormatted = base64.replace(dataPrefix, "");
      resolve(dataFormatted);
    };
    fileReader.readAsDataURL(file);
  });
};

export const base64ToArrayBuffer = (base64) => {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);

  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  };

  return bytes;
};

export const saveByteArray = (fileName, byte) => {
  var blob = new Blob([byte], { type: "application/pdf" });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};

export const saveByteArrayJpg = (fileName, byte) => {
  var blob = new Blob([byte], { type: "application/jpg" });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};

export const base64ToArrayBufferXlsx = (base64) => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
};

export const saveByteArrayXlsx = (fileName, byte) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(byte);
  link.download = fileName;
  link.click();
};

export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {

        if (!file || !(file instanceof Blob)) {
            resolve(""); 
            return;
        }

        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result.split(',')[1];
            resolve(base64);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
    });
};
